module.exports = __webpack_public_path__ + "static/media/1.a9807757.png";